import { render, staticRenderFns } from "./InvRL_List_Items.vue?vue&type=template&id=af64a192"
import script from "./InvRL_List_Items.vue?vue&type=script&lang=js"
export * from "./InvRL_List_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports